'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { HowItWorks } from '../../landing/shared/HowItWorks';

export function HowItWorksSection() {
  const t = useTranslations('creator.eventFaqBot.howItWorks');

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: 'grey.50',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          component="h2"
          fontWeight={700}
          textAlign="center"
          sx={{ mb: { xs: 4, md: 5 } }}
        >
          {t('title')}
        </Typography>
        <HowItWorks showNumbers direction="horizontal" />
      </Container>
    </Box>
  );
}
